const SectionName = ({ name }: { name: string }) => {
  return <h3 className="text-gray">{name}</h3>;
};

export default SectionName;
